import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltungs-typ-feld-anlegen';
import * as api from '../../../clients/veranstaltungstypen';

@Injectable()
export class VeranstaltungstypenVeranstaltungsTypFeldAnlegenEffects {

    VeranstaltungsTypFeldAnlegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_VERANSTALTUNGS_TYP_FELD_ANLEGEN),
        mergeMap((x: ac.PostVeranstaltungsTypFeldAnlegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postVeranstaltungsTypFeldAnlegen(x.veranstaltungsTypFeldRequest).pipe(
                map((result: any) => {
                    return new ac.PostVeranstaltungsTypFeldAnlegenErfolgreichAction(result, x.veranstaltungsTypFeldRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostVeranstaltungsTypFeldAnlegenFehlerAction(error, x.veranstaltungsTypFeldRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VeranstaltungsTypenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VeranstaltungsTypenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.VeranstaltungsTypenCommandService);
        }
        return this.service;
    }
}
